import { PressableProps, Text } from "react-native";
import { Feather } from "@expo/vector-icons";

import { Button } from "~/ui/Button";

export function SelectablePill({
  isChecked,
  iconBefore,
  iconAfter,
  ...props
}: PressableProps & {
  isChecked: boolean;
  iconBefore?: { web: React.ComponentProps<typeof Feather>["name"] };
  iconAfter?: { web: React.ComponentProps<typeof Feather>["name"] };
}) {
  if (typeof props.children === "string" && (iconBefore || iconAfter)) {
    console.warn(
      "SelectablePill: iconBefore/iconAfter is ignored when children is not a string",
    );
  }

  return (
    <Button
      {...props}
      variant={isChecked ? "primary" : "outline"}
      size="small"
      className="h-auto items-center rounded-full px-2 py-0.5"
    >
      {typeof props.children === "string" ? (
        <>
          {iconBefore?.web && (
            <Feather
              name={iconBefore.web}
              size={16}
              className="text-text-primary"
            />
          )}
          <Text className="text-text-primary">{props.children}</Text>
          {iconAfter?.web && (
            <Feather
              name={iconAfter.web}
              size={16}
              className="text-text-primary"
            />
          )}
        </>
      ) : (
        props.children
      )}
    </Button>
  );
}
